import { useDispatch } from 'react-redux';
import { EventManager } from 'interfaces/eventManager.interface';
import { KEY } from 'constants/local_storage_key.constant';
import { EventManagerNavigationBarSkeleton } from 'features/header_navigation_event_manager/components/eventManagerNavigationBarSkeleton.component';
import { EventManagerIcon } from '@common_components/icons/eventManager.icon';
import { Button, CommonGlobalService, HNBBreadcrumbItem, Sector, SectorIcon } from '@umanforge/common';
import { clearVisualisationToken } from '@umanforge/common/dist/store/slices/visualisation_token.slices';
import { DisconnectIcon } from '@common_components/icons/disconnect.icon';
import { useTranslation } from 'react-i18next';

interface VisualisationEventManagerHeaderProps {
  sector?: Sector | null;
  eventManager: EventManager;
}

function VisualisationEventManagerHeader( { eventManager, sector }: VisualisationEventManagerHeaderProps ) {

  const dispatch = useDispatch();
  const { t } = useTranslation();

  return (
    <div className='mx-4 my-2'>
      <EventManagerNavigationBarSkeleton
        eventManagerId={ eventManager.id }
        isViewMode={ true }
        selectedClientIdKey={ KEY.SELECTED_CLIENT_ID }
        selectedSiteIdKey={ KEY.SELECTED_SITE_ID }
        selectedSectorIdKey={ KEY.SELECTED_SECTOR_ID }
        setIsPopupVisible={ () => { return; } }
        isPopupVisible={ false }
        onSectorChanged={ () => { return; } }
        updateTable={ () => { return new Promise( resolve => { resolve( null ); } ); } }
        deleteTable={ () => { return new Promise( resolve => { resolve( true ); } ); } }
      >
        <div className='flex w-full items-center py-0.5'>
          <div className='flex flex-wrap gap-4 my-1 items-center w-full h-full'>
            {
              sector && (
                <HNBBreadcrumbItem
                  icon={ SectorIcon }
                  label={ sector.name }
                  data={ [] }
                  onItemSelect={ () => { return; } }
                />
              )
            }
            <HNBBreadcrumbItem
              icon={ EventManagerIcon }
              label={ eventManager.name }
              data={ [] }
              onItemSelect={ () => { return; } }
            />
          </div>
          <div className='justify-self-end'>
            <Button
              icon={ <DisconnectIcon size={ 5 } /> }
              onClick={ () => {
                dispatch( clearVisualisationToken() );
                CommonGlobalService.openAuthPage();
              } }
              className='relative group rounded-md p-2 trans-fast bg-transparent text-black hover:text-black shadow border border-gray-50'
              tooltip={ t( 'common:disconnect' ) }
            />
          </div>
        </div>
      </EventManagerNavigationBarSkeleton>
    </div>
  );
}

export default VisualisationEventManagerHeader;
